import { useState } from 'react';
import { Box, PasswordInput, Popover, Progress, Text } from '@mantine/core';
import { passwordRequirements, getPasswordStrength } from '../helpers/passwordValidation';
import GreenTick from '../assets/images/module/general/GreenTick.svg';
import RedCross from '../assets/images/module/general/RedCross.svg';
import GrayTick from '../assets/images/module/general/GrayTick.svg';

const TEXT_COLOR = '#13135C';
const BORDER_COLOR = '#DADAE5';

// Grey before anything is typed, then red until the requirement is met.
const requirementIcon = (met, password) => (met ? GreenTick : password ? RedCross : GrayTick);

const strengthColor = (strength) => (strength === 100 ? '#059266' : strength > 50 ? '#D97706' : '#E8193C');

// Password field with the requirement callout shown while it has focus. Used by every form where a
// user picks a new password (registration, redeem registration, password reset), so the list comes
// only from passwordRequirements. Takes PasswordInput's props, including form.getInputProps(...).
const PasswordGuidanceInput = ({ position, ...inputProps }) => {
  const [opened, setOpened] = useState(false);
  const password = inputProps.value ?? '';
  const strength = getPasswordStrength(password);

  return (
    <Popover
      opened={opened}
      position={position ?? (window.innerWidth < 993 ? 'top' : 'left')}
      trapFocus={false}
      withArrow
      shadow="md"
      transitionProps={{ transition: 'pop' }}
      width="target"
    >
      <Popover.Target>
        <div onFocusCapture={() => setOpened(true)} onBlurCapture={() => setOpened(false)}>
          <PasswordInput {...inputProps} />
        </div>
      </Popover.Target>
      <Popover.Dropdown bg="white" style={{ borderColor: BORDER_COLOR, color: TEXT_COLOR }}>
        <Progress color={strengthColor(strength)} value={strength} size={7} mb={12} styles={{ root: { backgroundColor: BORDER_COLOR } }} />
        {passwordRequirements.map((requirement) => {
          const met = requirement.regex.test(password);
          return (
            <Text key={requirement.label} c={TEXT_COLOR} size="sm" mt={7} style={{ display: 'flex', alignItems: 'center' }}>
              <img width={15} height={15} src={requirementIcon(met, password)} alt={met ? 'erfüllt' : 'nicht erfüllt'} />
              <Box component="span" ml={10}>{requirement.label}</Box>
            </Text>
          );
        })}
      </Popover.Dropdown>
    </Popover>
  );
};

export default PasswordGuidanceInput;
